import BasicDatatable from "../../Common/BasicDatatable"

const BusinessStatsSlideoverInteraction = () => {

  return (
    <div>
      <BasicDatatable columns={[]} rows={[]} rowCount={0}      />
    </div>
  )
}

export default BusinessStatsSlideoverInteraction